/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect } from 'react';
import { Tooltip, Typography } from '@mui/material';
import useStyles from './TaskBanner.styles';
import { get, size, uniqBy, last } from 'global/lib/lodash';
import ReassignModal from '../../task/TaskNotify/ReassignModal';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { userHasPermissions } from 'redux/actions/userLogin';
import { Loader } from 'global/styles';
import { useUser } from 'global/hooks/useUser';
import clsx from 'clsx';
import { Row } from 'global/components/row';
import ShareModal from '../../task/TaskNotify/ShareModal';
import sendData from 'redux/actions/sendData';
import { createAppUrl, stringObj } from '../../../global/utils';
import { Button } from 'global/components/Button';
import { Checkbox } from '../../../global/components/checkbox';

const SELECTALL = 'SELECT_ALL';

export default (props) => {
  const { assessment, realm_id, selectedItems, setSelectedItems, visible, disabled, allItems, itemPasses, showSelectBoxes, setShowSelectBoxes } = props;
  const classes = useStyles();
  const [amt, setAmt] = useState({ checkpoints: 0, total: 0 });
  const [showModal, setShowModal] = useState({ open: false });
  const { me } = useUser();
  const [userParams] = useState({
    waitFor: props.realm_id,
    build: ['users'],
    params: { filter: { content_realm_id: props.realm_id } },
    useCache: { reload: 1 },
  });
  const [shareLoading, setShareLoading] = useState(false);
  const [shareModal, setShareModal] = useState({ open: false });

  const users = useRetrieveData({ url: '/users' }, userParams);

  const getAmt = () => {
    const checkpoints = Object.keys(selectedItems).filter((k) => get(selectedItems, [k, 'itemType']) === 'checkpoint');
    const notSelectAll = Object.keys(selectedItems).filter((k) => get(selectedItems, [k, 'id']) !== SELECTALL);
    const checksize = size(checkpoints);

    let totalAmt = 0;

    const checkChildren = (item) => {
      const passed = itemPasses(item);
      if (item.children) {
        item.children.map(checkChildren);
      }
      if (passed) {
        totalAmt += 1;
      }
    };

    allItems.map(checkChildren);

    return {
      checkpoints: checksize,
      selCheckpoints: checkpoints,
      total: totalAmt,
      totalSelected: size(notSelectAll),
      selectAll: Object.keys(selectedItems).find((k) => get(selectedItems, [k, 'id']) == SELECTALL),
    };
  };

  useEffect(() => {
    setAmt(getAmt());
  }, [selectedItems, allItems]);

  const addTasks = () => {
    const assignee = get(props, 'assessment.assignees.0', me);
    const assignees = uniqBy([assignee, ...(users.data || [])], 'id');

    setShowModal({
      open: true,
      title: 'Create Tasks',
      okButton: 'Create',
      tasks: [{ assignees: [assignee] }],
      selectedItems,
      showTrades: true,
      onFormSubmit: props.onCreateTasks,
      assignees: assignees,
      onClose: () => {
        setShowModal({ open: false });
        document.getElementsByTagName('body')[0].style = '';
      },
    });
  };

  const printTasks = async () => {
    try {
      if (shareLoading) {
        return;
      }

      setShareLoading(true);

      const checkpoints = Object.keys(selectedItems)
        .filter((k) => get(selectedItems, [k, 'itemType']) === 'checkpoint')
        .map((k) => selectedItems[k]);
      const scorecard_score_ids = [];
      const sub_score_ids = [];

      checkpoints.map((cp) => {
        const { isSubScore } = cp;
        const scid = `${get(cp, `scorecardScoreId`)}`;
        if (isSubScore) {
          sub_score_ids.push(cp.id);
        } else {
          scorecard_score_ids.push(scid);
        }
      });

      const assessment_id = get(assessment, 'id');
      const assessment_name = get(assessment, 'name');

      const relationships = {
        scorecardScores: {
          data: scorecard_score_ids.map(id => ({ type: 'scorecard-scores', id: id.toString() }))
        },
        subScores: !size(sub_score_ids) ? undefined : {
          data: sub_score_ids.map(id => ({ type: 'sub-scores', id: id.toString() })),
        }
      }

      const result = await sendData(
        {
          url: `/messages`,
          method: 'post',
          data: {
            data: {
              type: 'messages',
              attributes: stringObj({
                model_type: 'assessment',
                model_id: assessment_id,
                realm_id,
                status: 1,
                body: 'Test',
              }),
              relationships,
            },
          },
        },
        { normalize: { build: ['messages'] }, params: { include: 'media' } }
      );

      const link = get(last(result), `media.0.full7DayUrl`);

      setShareModal({
        open: true,
        link,
        isScorePdf: true,
        title: 'Share Score PDF',
        tasks: [],
        emailText: `Assessment scores from ${assessment_name} have been shared with you. Please review the PDF here: 

${link}

See the entire Assessment here:

${createAppUrl('')}

Thanks,
`,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setShareLoading(false);
      setSelectedItems({});
      setShowSelectBoxes(false);
    }
  };

  const hasPerms = userHasPermissions('createTasks');
  const isZero = amt.checkpoints === 0;
  const indeterminate = !isZero && amt.totalSelected < amt.total;
  const isChecked = amt.totalSelected >= amt.total && amt.totalSelected > 0;

  const onCheckChange = (e) => {
    props.selectItem({
      id: SELECTALL,
      selectAll: indeterminate || isChecked ? false : true,
      checked: e.target.checked,
      value: 100,
      notes: ' ',
    });
  };

  return !visible ? null : (
    <>
      <div className={clsx(classes.container, !showSelectBoxes && classes.containerNone, disabled && classes.disabled)}>
        <div className={classes.innerContainer}>
          <Checkbox classes={{ root: classes.checkbox }} checkProps={{ indeterminate, disabled }} checked={isChecked} onChange={onCheckChange} color="default" />
          <Typography variant="body2">{!showSelectBoxes ? '' : `${amt.checkpoints} items selected`}</Typography>
          <Row style={{ marginLeft: 'auto' }}>
            {showSelectBoxes && (
              <Tooltip arrow placement="top" title={!hasPerms ? 'You do not have access to create tasks' : 'Create Tasks'}>
                <span className={classes.addButton}>
                  {users.loading ? (
                    <span>
                      Loading Users... <Loader size={16} />
                    </span>
                  ) : (
                    <Button disabled={disabled || isZero || !hasPerms} color="secondary" variant="contained" onClick={addTasks}>
                      {'CREATE TASKS'}
                    </Button>
                  )}
                </span>
              </Tooltip>
            )}
            {showSelectBoxes && (
              <Tooltip arrow placement="top" title={'Print Items'}>
                <span className={classes.addButton}>
                  {users.loading ? (
                    <span>
                      Loading Users... <Loader size={16} />
                    </span>
                  ) : (
                    <Button disabled={isZero} loading={shareLoading} color="secondary" variant="contained" onClick={printTasks}>
                      {'PRINT ITEMS'}
                    </Button>
                  )}
                </span>
              </Tooltip>
            )}
          </Row>
        </div>
      </div>

      <ReassignModal {...showModal} />

      <ShareModal {...shareModal} onClose={() => setShareModal({ open: false })} actions={{}} />
    </>
  );
};
